import React, { useContext, useEffect, useRef } from "react";
import styled from "styled-components";

// component imports
import ButtonSquare from "../../../../Components/ButtonSquare/ButtonSquare";

// other imports
import checkedIcon from "./Static/checked-icon.svg";
import subtractIcon from "./Static/subtract.svg";
import subtractMobileIcon from "./Static/subtract-mobile.svg";
import deviceMobile1 from "./Static/device-mobile-1.png";
import deviceMobile2 from "./Static/device-mobile-2.png";
import mockupsMobile from "./Static/mockups-mobile.png";
import mockupsMobileRight from "./Static/mockups-mobile-right.png";

import { Link } from "react-router-dom";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { API } from "../../../../Consts/Api";
import { useTranslation } from "react-i18next";
import theme from "../../../../Consts/Theme";
import {
  Header25,
  Header32,
  Header40,
  Text16,
} from "../../../../Components/Text/Text";

// styled-components
const ChooseAcademyTestWrapper = styled.section`
  width: 100%;
  background: linear-gradient(
    179deg,
    #7497ff 11.22%,
    rgba(116, 151, 255, 0) 98.87%
  );
  padding-top: 120px;
  padding-bottom: 100px;
  position: relative;
  overflow: hidden;

  img.star-horizontal {
    display: block;
    position: absolute;
    left: 50%;
    bottom: 0;
  }

  img.screen-desktop {
    display: block;
    width: 55%;
    position: absolute;
    z-index: 2;
    right: 0;
    right: -20%;
    top: 50%;
    transform: translateY(-40%);
  }

  @media (max-width: 768px) {
    padding-top: 56px;
    padding-bottom: 0;
  }
  @media (max-width: 992px) {
    img.screen-desktop {
      display: none;
    }
  }
  @media (max-width: 1920px) {
    img.screen-desktop {
      width: 50%;
    }
  }
`;
const StyledInnerWrap = styled.div`
  width: 90%;
  max-width: 1300px;
  margin: 0 auto ;

  ${Header32} {
    text-align: center;
    font-size: 48px;
    line-height: normal;
    margin-bottom: 100px;
    display: block;
  }
  ${Header32} span.highlight {
    border-bottom: 2px solid #4b4bff;
    display: inline-block;
  }
  ${Header25} {
    display: none;
  }

  @media (max-width: 768px) {
    ${Header32} {
      display: none;
    }
    ${Header25} {
      display: block;
    }
    ${Header25} span {
      /* text-transform: uppercase; */
      border-bottom: 2px solid #4b4bff;
    }
  }
`;
const StyledCaption = styled.div`
  margin-top: 32px;
  margin-bottom: 18px;

  ${Text16} {
    text-transform: uppercase;
  }

  ${Text16} span.highlight {
    border-bottom: 2px solid #4b4bff;
    display: inline-block;
    font-size: 15px;
  }
  ${Text16} span.highlight span.number {
    font-family: NextArt;
  }

  @media (max-width: 768px) {
    margin-top: 24px;
    margin-bottom: 12px;
  }
`;

const StyledChooseAcademyTest = styled.div`
  border-radius: 20px;
  background: #beceff;
  padding: 10px;
  position: relative;

  div.inner-container {
    border-radius: 16px;
    background: #fff;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    padding: 56px 0 72px 56px;
    height: 100%;
    position: relative;
    display: flex;
    overflow: hidden;
  }

  div.inner-container div.device-desktop {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 50%;
    display: block;
  }
  div.inner-container div.device-desktop img {
    width: 100%;
  }
  div.inner-container img.device-ipod {
    position: absolute;
    top: 0;
    right: 10px;
    width: 25%;
  }
  div.inner-container img.device-mobile {
    position: absolute;
    top: 0;
    right: 240px;
  }
  ${Header40} {
    display: block;
  }
  ${Header25} {
    display: none;
  }

  div.inner-container img.mockup-mobile-right,
  div.inner-container img.mockup-mobile {
    display: none;
  }

  @media (max-width: 768px) {
    div.inner-container img.mockup-mobile {
      display: block;
      position: absolute;
      bottom: -50px;
      left: -50px;
    }
  }
  @media (min-width: 376px) and (max-width: 400px) {
    div.inner-container img.mockup-mobile-right {
      display: block;
      position: absolute;
      bottom: -94px;
      right: -195px;
    }
  }
  @media (min-width: 401px) and (max-width: 768px) {
    div.inner-container img.mockup-mobile-right {
      display: block;
      position: absolute;
      bottom: -94px;
      right: -200px;
    }
  }
 
  @media (min-width: 1024px) and (max-width: 1399px) {
    div.inner-container div.device-desktop {
      width: 70%;
    }
    div.inner-container img.device-ipod {
      position: absolute;
      right: 0;
      width: 40%;
    }
  }
  @media (min-width: 769px) and (max-width: 1400px) {
    div.inner-container div.device-desktop {
      position: absolute;
      bottom: -100px;
      right: -280px;
    }
    div.inner-container img.device-ipod {
      position: absolute;
      top: 0;
      right: -100px;
    }
    div.inner-container img.device-mobile {
      display: none;
    }
  }

  @media (max-width: 992px) {
    margin-top: 50px;

    img.device-mobile-2 {
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
    }

    div.inner-container {
      padding: 32px 16px;
      display: block;
      overflow: hidden;
    }
    ${Text16} {
      font-size: 13px;
    }
    ${Header40} {
      display: none;
    }
    ${Header25} {
      display: block;
    }
  }
`;

const StyledButtonsGroup = styled.div`
  margin: 32px 0 auto;
  display: grid;
  grid-row-gap: 16px;

  @media (max-width: 992px) {
    margin: 24px 0 200px;
  }
  @media (min-width: 992px) {
    p.choose-program {
      margin-left: 50px;
    }

    button {
      border-radius: 50px;
      transition: all 0.3s ease-in-out;
    }
  }
`;
const StyledButtonWrap = styled.div`
  a,
  button {
    width: 100%;
  }
`;

const ImagesDesktop = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
  @media (min-width: 768px) and (max-width: 1400px) {
    overflow: hidden;
    border-radius: 50px;
  }
`;

const StyledAdmissionSteps = styled.div`
  border-radius: 20px;
  background: #beceff;
  padding: 10px;
  margin-top: 32px;
  font-family: Raleway;

  div.inner-container {
    border-radius: 16px;
    background: #fff;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    padding: 56px 56px 72px 56px;
    height: 100%;
    position: relative;
    display: flex;
  }

  div.subtract-icon-container {
    padding-left: 30px;
  }
  article.step-desktop p.step-number,
  article.step-mobile p.step-number {
    color: #161616;
    font-size: 12px;
    line-height: 16px;
  }
  article.step-desktop h3.step-title {
    color: #161616;
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 8px;
  }
  article.step-desktop div.step-description p,
  article.step-mobile div.step-description p {
    color: #6a6a6a;
    font-size: 15px;
    line-height: 24px;
  }
  article.step-desktop div.subtract-icon-placeholder {
    height: 80px;
  }
  article.step-mobile {
    display: none;
  }

  @media (max-width: 1400px) {
    div.inner-container {
      flex-direction: column;
      padding: 60px 28px;
    }
    article.step-desktop {
      display: none;
    }
    article.step-mobile {
      display: flex;
    }
    article.step-mobile div.content-mobile {
      margin-top: -20px;
    }
    article.step-mobile h3.step-title {
      color: #161616;
      font-family: Raleway;
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 8px;
    }
    article.step-mobile.step-3 {
      margin-left: 32px;
    }
  }
`;

const ChooseAcademyTest = (props) => {
  const { t } = useTranslation();
  const scrollToSectionRef = useRef(null);
  const { academies, userInfo } = useContext(GlobalContext);

  const updatedAcademies = academies.map((academy, index) => {
    return {
      ...academy,
      backgroundImage: `/frame-${index + 1}.svg`,
    };
  });

  const offset = 100;

  useEffect(() => {
    if (props.scrollToTests) {
      const topPosition =
        scrollToSectionRef?.current?.getBoundingClientRect()?.top +
        window.scrollY -
        offset;
      window.scrollTo({ top: topPosition, behavior: "smooth" });
      props.resetButton();
    }
  }, [props.scrollToTests]);

  return (
    <ChooseAcademyTestWrapper>
      <StyledInnerWrap>
        <Header32
          color={theme.white}
          fontWeight={600}
          dangerouslySetInnerHTML={{
            __html: t("homepage.choose_academy_test.title"),
          }}
        ></Header32>
        <Header25 color={theme.white} fontWeight={600}>
          Единствениот практичен акредитиран IT факултет, кој ти овозможува -{" "}
          <br />
          <span className="highlight">да плаќаш по вработување!</span>
        </Header25>
        <StyledChooseAcademyTest ref={scrollToSectionRef}>
          <div className="inner-container">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M7.99937 26.153C7.40715 26.153 6.90015 25.9421 6.47837 25.5204C6.05659 25.0986 5.8457 24.5916 5.8457 23.9994C5.8457 23.4071 6.05659 22.9001 6.47837 22.4784C6.90015 22.0566 7.40715 21.8457 7.99937 21.8457C8.59159 21.8457 9.09859 22.0566 9.52037 22.4784C9.94215 22.9001 10.153 23.4071 10.153 23.9994C10.153 24.5916 9.94215 25.0986 9.52037 25.5204C9.09859 25.9421 8.59159 26.153 7.99937 26.153ZM7.99937 18.153C7.40715 18.153 6.90015 17.9421 6.47837 17.5204C6.05659 17.0986 5.8457 16.5916 5.8457 15.9994C5.8457 15.4071 6.05659 14.9001 6.47837 14.4784C6.90015 14.0566 7.40715 13.8457 7.99937 13.8457C8.59159 13.8457 9.09859 14.0566 9.52037 14.4784C9.94215 14.9001 10.153 15.4071 10.153 15.9994C10.153 16.5916 9.94215 17.0986 9.52037 17.5204C9.09859 17.9421 8.59159 18.153 7.99937 18.153ZM7.99937 10.153C7.40715 10.153 6.90015 9.94215 6.47837 9.52037C6.05659 9.09859 5.8457 8.59159 5.8457 7.99937C5.8457 7.40715 6.05659 6.90015 6.47837 6.47837C6.90015 6.05659 7.40715 5.8457 7.99937 5.8457C8.59159 5.8457 9.09859 6.05659 9.52037 6.47837C9.94215 6.90015 10.153 7.40715 10.153 7.99937C10.153 8.59159 9.94215 9.09859 9.52037 9.52037C9.09859 9.94215 8.59159 10.153 7.99937 10.153ZM15.9994 10.153C15.4071 10.153 14.9001 9.94215 14.4784 9.52037C14.0566 9.09859 13.8457 8.59159 13.8457 7.99937C13.8457 7.40715 14.0566 6.90015 14.4784 6.47837C14.9001 6.05659 15.4071 5.8457 15.9994 5.8457C16.5916 5.8457 17.0986 6.05659 17.5204 6.47837C17.9421 6.90015 18.153 7.40715 18.153 7.99937C18.153 8.59159 17.9421 9.09859 17.5204 9.52037C17.0986 9.94215 16.5916 10.153 15.9994 10.153ZM23.9994 10.153C23.4071 10.153 22.9001 9.94215 22.4784 9.52037C22.0566 9.09859 21.8457 8.59159 21.8457 7.99937C21.8457 7.40715 22.0566 6.90015 22.4784 6.47837C22.9001 6.05659 23.4071 5.8457 23.9994 5.8457C24.5916 5.8457 25.0986 6.05659 25.5204 6.47837C25.9421 6.90015 26.153 7.40715 26.153 7.99937C26.153 8.59159 25.9421 9.09859 25.5204 9.52037C25.0986 9.94215 24.5916 10.153 23.9994 10.153ZM15.9994 18.153C15.4071 18.153 14.9001 17.9421 14.4784 17.5204C14.0566 17.0986 13.8457 16.5916 13.8457 15.9994C13.8457 15.4071 14.0566 14.9001 14.4784 14.4784C14.9001 14.0566 15.4071 13.8457 15.9994 13.8457C16.5916 13.8457 17.0986 14.0566 17.5204 14.4784C17.9421 14.9001 18.153 15.4071 18.153 15.9994C18.153 16.5916 17.9421 17.0986 17.5204 17.5204C17.0986 17.9421 16.5916 18.153 15.9994 18.153ZM17.4867 24.948V23.1327C17.4867 22.9758 17.5157 22.8237 17.5737 22.6764C17.6319 22.5293 17.7234 22.3934 17.848 22.2687L24.725 15.425C24.8908 15.2593 25.0698 15.1426 25.262 15.075C25.4543 15.0075 25.6465 14.9737 25.8387 14.9737C26.0483 14.9737 26.251 15.013 26.447 15.0917C26.643 15.1704 26.8211 15.2884 26.9814 15.4457L28.2147 16.6917C28.3583 16.8575 28.4694 17.0369 28.548 17.23C28.6267 17.4234 28.666 17.6166 28.666 17.8097C28.666 18.0028 28.6301 18.1994 28.5584 18.3994C28.4866 18.5994 28.372 18.7823 28.2147 18.948L21.371 25.7917C21.2464 25.9164 21.1105 26.0078 20.9634 26.066C20.816 26.124 20.6639 26.153 20.507 26.153H18.6917C18.3501 26.153 18.0639 26.0376 17.833 25.8067C17.6021 25.5758 17.4867 25.2896 17.4867 24.948ZM19.0764 24.5634H20.343L24.671 20.2147L24.0584 19.5814L23.4377 18.9557L19.0764 23.2967V24.5634ZM24.0584 19.5814L23.4377 18.9557L24.671 20.2147L24.0584 19.5814Z"
                  fill="url(#paint0_linear_15945_457)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_15945_457"
                    x1="17.2559"
                    y1="5.8457"
                    x2="17.2559"
                    y2="26.153"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#7497FF" />
                    <stop offset="1" stop-color="#4B4BFF" />
                  </linearGradient>
                </defs>
              </svg>
              {/* Caption */}
              <StyledCaption>
                <Text16
                  fontWeight={600}
                  lineHeight="24"
                  dangerouslySetInnerHTML={{
                    __html: t("homepage.choose_academy_test.header_part_one"),
                  }}
                ></Text16>
              </StyledCaption>
              {/* Subheader */}
              <Header40
                dangerouslySetInnerHTML={{
                  __html: t("homepage.choose_academy_test.subheader"),
                }}
              ></Header40>
              <Header25 fontWeight={600}>
                Реши го приемниот тест <br /> за акредитираните <br />{" "}
                додипломски програми.
              </Header25>
              {/* Buttons group */}
              <StyledButtonsGroup>
                {updatedAcademies?.length > 0 &&
                  updatedAcademies.map((academy) => (
                    <StyledButtonWrap key={academy.id}>
                      <Link
                        target="_blank"
                        to={
                          userInfo.academy_id
                            ? API.createRoute("ongoing")
                            : userInfo.referred_by !== null
                            ? API.createRoute("applyWithReferral", {
                                REFERRAL_GUID: userInfo.referred_by,
                                ACADEMY_ID: academy.id,
                              })
                            : API.createRoute("apply", {
                                ACADEMY_ID: academy.id,
                              })
                        }
                      >
                        <ButtonSquare
                          btnText={academy.name}
                          borderColor={
                            academy.id === 1
                              ? `${theme.altBlue}`
                              : `${theme.pink}`
                          }
                          hoverColor="linear-gradient(92.5deg, #7497FF -3.1%, #FFFFFF 106.84%)"
                          backgroundImage={academy.backgroundImage}
                        />
                      </Link>
                    </StyledButtonWrap>
                  ))}
              </StyledButtonsGroup>
            </div>

            <ImagesDesktop>
              <img src="/device-mobile.png" alt="" className="device-mobile" />
              <img src="/device-ipod.png" alt="" className="device-ipod" />
              <div className="device-desktop">
                <img src="/device-desktop.png" alt="" />
              </div>
            </ImagesDesktop>
            {/* Mobile */}
            <img src={mockupsMobile} alt="" className="mockup-mobile" />
            <img
              src={mockupsMobileRight}
              alt=""
              className="mockup-mobile-right"
            />
          </div>
        </StyledChooseAcademyTest>

        <StyledAdmissionSteps>
          <div className="inner-container">
            {/* First step */}
            <article className="step-desktop">
              <div className="subtract-icon-container">
                <img src={subtractIcon} alt="" className="subtract-icon" />
              </div>
              <div className="checked-icon-container">
                <img src={checkedIcon} alt="" />
              </div>
              <p className="step-number">Чекор 1</p>
              <h3 className="step-title">Приемен тест</h3>
              <div className="step-description">
                <p>Само за матуранти</p>
                <p>45 Минути</p>
                <p>40 Прашања</p>
              </div>
            </article>
            {/* First step mobile */}
            <article className="step-mobile">
              <div>
                <img src={subtractMobileIcon} alt="" />
              </div>
              <div className="content-mobile">
                <div className="checked-icon-container">
                  <img src={checkedIcon} alt="" />
                </div>
                <p className="step-number">Чекор 1</p>
                <h3 className="step-title">Приемен тест</h3>
                <div className="step-description">
                  <p>Само за матуранти</p>
                  <p>45 Минути</p>
                  <p>40 Прашања</p>
                </div>
              </div>
            </article>
            {/* Second step */}
            <article className="step-desktop">
              <div className="subtract-icon-container">
                <img src={subtractIcon} alt="" className="subtract-icon" />
              </div>
              <div className="checked-icon-container">
                <img src={checkedIcon} alt="" />
              </div>
              <p className="step-number">Чекор 2</p>
              <h3 className="step-title">
                Телефонски повик со <br />
                нашиот тим
              </h3>
              <div className="step-description">
                <p>
                  Повик за резултатите и <br /> информации за факултетот и{" "}
                  <br /> начинот на студирање!
                </p>
              </div>
            </article>
            {/* Second step mobile */}
            <article className="step-mobile">
              <div>
                <img src={subtractMobileIcon} alt="" />
              </div>
              <div className="content-mobile">
                <div className="checked-icon-container">
                  <img src={checkedIcon} alt="" />
                </div>
                <p className="step-number">Чекор 2</p>
                <h3 className="step-title">
                  Телефонски повик со <br />
                  нашиот тим
                </h3>
                <div className="step-description">
                  <p>
                    Повик за резултатите и информации за факултетот и начинот на
                    студирање!
                  </p>
                </div>
              </div>
            </article>
            {/* Third step */}
            <article className="step-desktop">
              <div className="subtract-icon-placeholder"></div>
              <div className="checked-icon-container">
                <img src={checkedIcon} alt="" />
              </div>
              <p className="step-number">Чекор 3</p>
              <h3 className="step-title">
                Стана дел од 100те <br /> одбрани студенти на <br />
                Brainster Next!
              </h3>
              <div className="step-description">
                <p>Подготви се заедно да го смениме светот.</p>
              </div>
            </article>
            {/* Third step mobile */}
            <article className="step-mobile step-3">
              <div className="content-mobile">
                <div className="checked-icon-container">
                  <img src={checkedIcon} alt="" />
                </div>
                <p className="step-number">Чекор 3</p>
                <h3 className="step-title">
                  Стана дел од 125те <br /> одбрани студенти на <br />
                  Brainster Next!
                </h3>
                <div className="step-description">
                  <p>Подготви се заедно да го смениме светот.</p>
                </div>
              </div>
            </article>
          </div>
        </StyledAdmissionSteps>
      </StyledInnerWrap>
    </ChooseAcademyTestWrapper>
  );
};

export default ChooseAcademyTest;
